import React, { Component } from "react";
import { Button } from "semantic-ui-react";

import "./ActionButton.css";

class ActionButton extends Component {
  render() {
    if (!this.props.show) return null;

    return (
      <Button
        className={this.props.className}
        color={this.props.color}
        onClick={this.props.onClick}
      >
        {this.props.buttonText}
      </Button>
    );
  }
}

export default ActionButton;
